import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ControlMatch } from '../models/control-state';

export interface SetOrderDialogData {
  match: ControlMatch;
  currentPosition: number;
  maxPosition: number;
}

@Component({
  selector: 'app-set-order-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './set-order-dialog.html',
  styleUrl: './set-order-dialog.scss',
})
export class SetOrderDialogComponent implements OnInit {
  private data: SetOrderDialogData = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<SetOrderDialogComponent>);
  private fb = inject(FormBuilder);

  match!: ControlMatch;
  currentPosition = 0;
  maxPosition = 0;

  form: FormGroup = this.fb.group({
    position: [1, [Validators.required, Validators.min(1)]],
  });

  ngOnInit(): void {
    this.match = this.data.match;
    this.currentPosition = this.data.currentPosition;
    this.maxPosition = this.data.maxPosition;

    this.form = this.fb.group({
      position: [
        this.currentPosition,
        [
          Validators.required,
          Validators.min(1),
          Validators.max(this.maxPosition),
        ],
      ],
    });
  }

  get player1Name(): string {
    return this.match.player1?.playerName || this.match.player1Id || '?';
  }

  get player2Name(): string {
    return this.match.player2?.playerName || this.match.player2Id || '?';
  }

  setQuick(pos: number): void {
    if (pos < 1) pos = 1;
    if (pos > this.maxPosition) pos = this.maxPosition;
    this.form.patchValue({ position: pos });
  }

  submit(): void {
    if (this.form.invalid) return;
    const target = Number(this.form.value.position);
    if (!target || target < 1 || target > this.maxPosition) return;
    this.dialogRef.close(target);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
